"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var CardOptionValue = require('./card-option-value');

var CardOption = /*#__PURE__*/function () {
  function CardOption(opt) {
    _classCallCheck(this, CardOption);

    this._id = null;
    this.campusCode = null;
    this.isInternal = false;
    this.name = null;
    this.options = [];
    this.tags = [];

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(CardOption, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      this._id = new ObjectId(opt._id);
      this.campusCode = opt.campusCode;
      this.isInternal = opt.isInternal || false;
      this.name = opt.name;
      this.tags = Array.isArray(opt.tags) ? _toConsumableArray(opt.tags) : [];

      if (opt.options) {
        opt.options.forEach(function (item) {
          return _this.options.push(new CardOptionValue(item));
        });
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, CardOption.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'card-option.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'object'
          },
          campusCode: {
            type: 'string'
          },
          isInternal: {
            type: 'boolean'
          },
          name: {
            type: 'string'
          },
          options: {
            type: 'array',
            items: {
              $ref: 'card-option-value.schema.json'
            }
          },
          tags: {
            type: 'array',
            item: {
              type: 'string'
            }
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return CardOption;
}();

tv4.addSchema(CardOptionValue.schema());
module.exports = CardOption;